// https://github.com/ymmooot/nuxt-jsonld/blob/v1/README.md
import Vue from 'vue';
import NuxtJsonld from 'nuxt-jsonld';

Vue.use(NuxtJsonld);